export default __webpack_public_path__ + "static/media/AKM_3.43a5e20c.png";